@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.name-and-reload {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: @space-64;
  padding: @space-16 0 @space-32 @space-16;
  background-color: var(--grid-header--default--background-color);

  > button {
    margin-left: @space-12;
  }

  > * svg {
    height: @space-12;
    width: @space-12;
    margin-right: @space-8;
  }
}

.header-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: @space-12;
  padding: @space-16 @space-16 @space-32 0;

  > button svg {
    height: @space-12;
    width: @space-12;
    margin-right: @space-8;
  }
}

.tabs {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tab-list {
  padding: 0 @space-24;
  background-color: var(--grid-header--default--background-color);
}

.actions-icon {
  > svg {
    height: @space-16;
    width: @space-16;
  }
}

.tab-count {
  display: inline-block;
  line-height: @space-16;
  color: @return-status-tabs--badge--text-color;
  background: @return-status-tabs--badge--background-color;
  border: 1px solid @return-status-tabs--badge--background-color;
  padding: 2px @space-8;
  margin-left: @space-8;
  border-radius: @space-16;

  &.selected {
    background: @return-status-tabs--badge--selected--background-color;
    color: @return-status-tabs--badge--selected--text-color;
  }
}
